import {
  // eslint-disable-next-line no-unused-vars
  h,
  render,
  Fragment,
} from 'preact';
import { useState, useEffect, useRef } from 'preact/hooks';
import Post from './Post';

const PageNumbers = (props) => {
  const { maxPages, page, setPage } = props;

  if (maxPages === 1) {
    return null;
  }

  const pages = [];
  for (let i = 1; i <= maxPages; i += 1) {
    if (i === page) {
      pages.push(<span className="page-numbers current">{i}</span>);
    } else if (
      (i < page + 3 && i > page) ||
      (i > page - 3 && i < page) ||
      i === 1 ||
      i === maxPages
    ) {
      pages.push(
        <button
          className="page-numbers"
          tabIndex="0"
          type="button"
          onClick={() => {
            if (i !== page) {
              setPage(i);
            }
          }}
        >
          {i}
        </button>,
      );
    } else if (i === page + 3 || i === page - 3) {
      pages.push(
        <button className="page-numbers" tabIndex="0" type="button" disabled>
          ...
        </button>,
      );
    }
  }

  return <div className="pagination">{pages}</div>;
};

const PostsGridWithPagination = (props) => {
  const { queryArgs } = props;
  const {
    post_type: postType,
    taxonomy_filter: taxonomy,
    taxonomy_name: taxonomyName,
    filters,
  } = queryArgs;

  const [posts, setPosts] = useState([]);
  const [tags, setTags] = useState([]);
  const [page, setPage] = useState(1);
  const [maxPages, setMaxPages] = useState(1);
  const [search, setSearch] = useState('');
  const [selectedTag, setSelectedTag] = useState('');
  const inputRef = useRef(null);

  const resetFilters = () => {
    setSearch('');
    setSelectedTag('');
    setPage(1);
  };

  const filterArr = Object.entries(filters);
  const filterQuery =
    filterArr.length > 0
      ? `&${filterArr.map(([tax, values]) => `${tax}=${values.join(',')}`).join('&')}`
      : '';

  useEffect(() => {
    fetch(`/wp-json/deepsea/v1/posts-grid-with-pagination-terms?taxonomy=${taxonomy}`, {
      method: 'GET',
    })
      .then((response) => response.json())
      .then((data) => {
        setTags(data);
      });
  }, [queryArgs]);

  useEffect(() => {
    const controller = new AbortController();
    const { signal } = controller;

    const fetchData = async () => {
      try {
        const response = await fetch(
          `/wp-json/deepsea/v1/posts-grid-with-pagination?s=${search}&page=${page}&tag=${selectedTag}&post_type=${postType}&taxonomy=${taxonomy}${filterQuery}`,
          { method: 'GET', signal },
        );
        return await response.json();
      } catch (e) {
        if (e.name !== 'AbortError') {
          throw e;
        }
      }

      return null;
    };

    fetchData().then((data) => {
      if (data) {
        setPosts(data.posts);
        setMaxPages(data.maxPages);
      }
    });

    return () => controller.abort();
  }, [page, search, selectedTag]);

  return (
    <>
      <div className="posts-grid-with-pagination--filters">
        <label>
          <input
            type="search"
            ref={inputRef}
            className="posts-grid-with-pagination__search"
            placeholder="Search"
            value={search}
            onInput={(e) => {
              const { target } = e;

              setSearch(target.value);
            }}
          />
        </label>
        <label>
          <select
            style={{ color: selectedTag === '' ? '#909090' : null }}
            className="posts-grid-with-pagination__category-select"
            value={selectedTag}
            onChange={(e) => {
              const { target } = e;

              setSelectedTag(target.value);
            }}
          >
            <option className="default-value" value="" hidden>
              {taxonomyName}
            </option>
            {tags.length > 0 && tags.map((tag) => <option value={tag.slug}>{tag.name}</option>)}
          </select>
        </label>
        <div className="posts-grid-with-pagination__clear-filters">
          <button
            type="reset"
            onClick={resetFilters}
            disabled={search === '' && selectedTag === ''}
          >
            Clear filters
          </button>
        </div>
      </div>
      <div className="posts-grid-with-pagination--posts">
        {posts.map((post) => (
          <Post key={post.id} post={post} />
        ))}
      </div>
      <PageNumbers page={page} setPage={setPage} maxPages={maxPages} />
    </>
  );
};

const elements = document.querySelectorAll('.posts-grid-with-pagination');
if (elements.length) {
  elements.forEach((el) => {
    const { queryArgs } = el.dataset;
    const parsedArgs = JSON.parse(queryArgs);
    render(<PostsGridWithPagination queryArgs={parsedArgs} page={1} />, el);
  });
}
